// extracted by mini-css-extract-plugin
export default {"source":"WebSearchSource__source--2TvnE","contains":"WebSearchSource__contains--10LrZ","match":"WebSearchSource__match--13GkR"};